import svgUrl from "ni:svgr;XrhHpHMg2tvYVTowrD6492BFj-eee9Pkd3DGDknBzmE";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const RightJoinLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><circle cx={11} cy={11} r={11} fill="var(--tbl--colors--icons--transformation--tertiary)" transform="matrix(-1 0 0 1 22 5)" /><circle cx={11} cy={11} r={11} fill="var(--tbl--colors--icons--transformation--primary)" transform="matrix(-1 0 0 1 32 5)" /><path fill="#fff" fillOpacity={0.2} fillRule="evenodd" d="M16 25.8a11 11 0 0 1-6-9.8 11 11 0 0 1 6-9.8 11 11 0 0 1 6 9.8 11 11 0 0 1-6 9.8Z" clipRule="evenodd" /></svg>;
const Memo = memo(RightJoinLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "RightJoinLIcon";
}